$(document).ready(() => {
  let container = $('#subscriptionCancelationData');
  if (container.length <= 0) { return; }

  subscribeToSubscriptionAutoCancelationChannel(container);
});

function subscribeToSubscriptionAutoCancelationChannel(container) {
  let redirectUrl = container.data('redirect-url');

  App.cable.subscriptions.create({
    channel: 'SubscriptionAutoCancelationChannel',
    subscription_id: container.data('subscription-id'),
  },
  {
    received(data) {
      if (data['status'] === 'canceled') {
        window.location.href = redirectUrl;
      };

      this.disconnect();
    }
  });
}

// Expose top-level declarations as globals (pre-bundler concatenation behavior).
window.subscribeToSubscriptionAutoCancelationChannel = subscribeToSubscriptionAutoCancelationChannel;
